'use client';
import React from 'react';
import { useRouter } from 'next/navigation';
import { Button } from '@/app/components/ui/Button';
import { PanelRight } from 'lucide-react';
import { cn } from '@/app/lib/utils';

export interface OpenButtonProps {
  url: string;
  external?: boolean;
  className?: string;
  alwaysShow?: boolean;
  onOpen?: () => void;
}

const OpenButton: React.FC<OpenButtonProps> = ({
  url,
  external = true,
  className,
  alwaysShow = false,
  onOpen,
}) => {
  const router = useRouter();

  return (
    <Button
      variant="outline"
      className={cn(
        'h-5 rounded-[6px] px-2 py-0 text-xs font-medium gap-1.5 text-foreground bg-background border-border hover:bg-secondary [&_svg]:size-3 pointer-events-auto',
        !alwaysShow && 'hidden group-hover:flex',
        alwaysShow && 'flex',
        className
      )}
      onClick={e => {
        e.stopPropagation();
        e.preventDefault();
        if (onOpen) {
          onOpen();
        } else if (external) {
          window.open(url, '_blank', 'noopener,noreferrer');
        } else {
          router.push(url);
        }
      }}
    >
      <PanelRight />
      Open
    </Button>
  );
};

export default OpenButton;
